module.exports = __webpack_public_path__ + "img/2.f7507629.png";